import { Box, BoxProps } from '@jfs/ui-new'
import { TextInput } from '../AdminInputs'
import { ButtonNew } from '../AdminButton'
import { useState } from 'react'

interface SearchByMidProps {
  onClick?: any
  initialSearchMid?: any
  onMidChange?: any
}

export const SearchByMid = ({ onClick = () => {}, initialSearchMid, onMidChange }: SearchByMidProps) => {
  console.log('initialSearchMid', initialSearchMid)
  const [mid, setMid] = useState('')

  return (
    <Box {...styles.container}>
      <Box f={1}>
        <TextInput
          placeholder="Search By Mid..."
          showBottomLine={false}
          fontSize={12}
          placeholderTextColor={'BLACK_21'}
          color={'BLACK_75'}
          onChangeText={(text) => {
            setMid(text)
            onMidChange(text)
          }}
          value={mid}
        />
      </Box>
      <ButtonNew
        type={'primaryIcon'}
        onPress={() => onClick(mid)}
        icon="SEARCH"
        height={34}
        borderRadius={4}
        width={50}
        iconPaddingRight={-30}
      />
    </Box>
  )
}

const styles = {
  container: {
    borderWidth: 1,
    borderColor: 'BORDER_COLOR',
    borderRadius: 4,
    width: 200,
    height: 34,
    pl: 4,
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 2,
    flexDirection: 'row',
  } as BoxProps,
}
